const office = (state) => {
  return (
    state.office.data || {
      _request: {},
      grouped: {},
      metadata: {},
      total: {},
      labels: [],
    }
  )
}

const officeLastUpdate = (state) => {
  return state.office.lastUpdate
}

const officeLoading = (state) => {
  return state.office.loading
}

const professionals = (state) => {
  return (
    state.professionals.data || {
      _request: {},
      grouped: {},
      metadata: {},
      total: {},
      labels: [],
    }
  )
}

const professionalsLastUpdate = (state) => {
  return state.professionals.lastUpdate
}

const professionalsLoading = (state) => {
  return state.professionals.loading
}

const clients = (state) => (id_profissional) => {
  // !TODO:Verificar se esta pegando o profissional certo
  return (
    state.clientsListed.data || {
      _request: {},
      grouped: {},
      metadata: {},
      total: {},
      labels: [],
    }
  )
}

const clientsLastUpdate = (state) => {
  return state.clientsListed.lastUpdate
}

const clientsLoading = (state) => {
  return state.clientsListed.loading
}

const clientsGrouped = (state) => (id_profissional) => {
  // !TODO:Verificar se esta pegando o profissional certo
  return (
    state.clientsGrouped.data || {
      _request: {},
      grouped: {},
      metadata: {},
      total: {},
    }
  )
}

const clientsGroupedLastUpdate = (state) => {
  return state.clientsGrouped.lastUpdate
}

const clientsGroupedLoading = (state) => {
  return state.clientsGrouped.loading
}

export {
  office,
  professionals,
  clients,
  officeLastUpdate,
  officeLoading,
  professionalsLastUpdate,
  professionalsLoading,
  clientsLastUpdate,
  clientsLoading,
  clientsGrouped,
  clientsGroupedLastUpdate,
  clientsGroupedLoading,
}
